<div class="w-full flex flex-col gap-y-2">
    <div class="flex flex-row items-center gap-x-4 w-full py-2">
        @if (editPostRequirementsService.editingPostRequirements()) {
        <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Post Requirements <span
                class="text-xs text-secondary">(Editing)</span></h2>
        } @else {
        <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Post Requirements</h2>
        }

        <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
        <button (click)="editPostRequirements()" type="button" [appTooltip]="'Edit Post Requirements'" position="left"
            class="fab-button-primary inline-flex shrink-0 items-center gap-x-1.5 px-3 py-1.5 text-sm font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                aria-hidden="true">
                <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path
                    d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
            </svg>
            Edit
        </button>
    </div>
    @if (editPostRequirementsService.editingPostRequirements()) {
    <article class="briefing-section-card relative isolate flex flex-col gap-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3">
            <div class="sm:col-span-1">
                <label for="edit-suggested-caption" class="block text-sm/6 font-medium text-primary">
                    Caption
                    <p class="text-xs text-secondary">Required caption to be used in the post.</p>
                </label>
                <div class="w-full mt-2">
                    <textarea id="edit-suggested-caption" rows="3" placeholder="Enter your caption here..."
                        [formField]="editPostRequirementsService.postRequirementsForm.suggestedCaption"
                        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"></textarea>
                </div>
            </div>
            <div class="sm:col-span-1">
                <label for="edit-suggested-hastags" class="block text-sm/6 font-medium text-primary">
                    Hashtags
                    <p class="text-xs text-secondary">Required hashtags to be used in the post.</p>
                </label>
                <div class="w-full mt-2">
                    <textarea id="edit-suggested-hastags" rows="3" placeholder="Enter your hashtags here..."
                        [formField]="editPostRequirementsService.postRequirementsForm.suggestedHastags"
                        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"></textarea>
                </div>
            </div>
            <div class="sm:col-span-1">
                <label for="edit-call-to-action-link" class="block text-sm/6 font-medium text-primary">
                    CTA Link
                    <p class="text-xs text-secondary">The link creators must share with their audience.</p>
                </label>
                <div class="mt-2 flex">
                    <div
                        class="flex shrink-0 items-center rounded-l-md bg-white px-3 text-base text-gray-500 outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 dark:bg-white/5 dark:text-gray-400 dark:outline-gray-700">
                        https://</div>
                    <input id="edit-call-to-action-link" type="url" placeholder="www.example.com"
                        [formField]="editPostRequirementsService.postRequirementsForm.callToActionLink"
                        class="-ml-px block w-full grow rounded-r-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-primary" />
                </div>
            </div>
        </div>

        <!-- Save Post Requirements Changes -->
        <div class="rounded-md bg-blue-50 p-4 dark:bg-blue-500/10 dark:outline dark:outline-blue-500/20">
            <div class="flex">
                <div class="shrink-0">
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="size-5 text-blue-400">
                        <path
                            d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-sm text-blue-700 dark:text-blue-300">Save your post requirements changes.</p>
                    <p class="mt-3 text-sm md:mt-0 md:ml-6">
                        @if (editPostRequirementsService.editInProgress()) {
                        <span
                            class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                            <svg aria-hidden="true"
                                class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>
                            Saving Post Requirements...
                        </span>
                        } @else {
                        <button (click)="savePostRequirementsChanges()" type="button"
                            class="font-medium whitespace-nowrap text-blue-700 hover:text-blue-600 dark:text-blue-300 dark:hover:text-blue-200 hover:cursor-pointer">
                            Save
                            <span aria-hidden="true"> &rarr;</span>
                        </button>
                        }
                    </p>
                </div>
            </div>
        </div>
        <!-- Save Post Requirements Changes - END -->
    </article>
    } @else {
    <article class="briefing-section-card relative isolate flex flex-col gap-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3">
            <div class="sm:col-span-1">
                <label for="comment" class="block text-sm/6 font-medium text-primary">
                    Caption
                    <p class="text-xs text-secondary">Required caption to be used in the post.</p>
                </label>
                @if (manageBriefTabsService.focussedBrief()!.shoutBrief!.suggestedCaption) {
                <div class="w-full mt-2">
                    <textarea id="about" rows="3" disabled
                        [value]="manageBriefTabsService.focussedBrief()!.shoutBrief!.suggestedCaption"
                        placeholder="Enter your caption here..."
                        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"></textarea>
                </div>
                } @else {
                <div class="w-full mt-2 flex flex-row items-center justify-start gap-x-2">
                    <span
                        class="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20">Un-Set</span>
                </div>
                }
            </div>
            <div class="sm:col-span-1">
                <label for="comment" class="block text-sm/6 font-medium text-primary">
                    Hashtags
                    <p class="text-xs text-secondary">Required hashtags to be used in the post.</p>
                </label>
                @if (manageBriefTabsService.focussedBrief()!.shoutBrief!.suggestedHastags) {
                <div class="w-full mt-2">
                    <textarea id="about" rows="3" disabled
                        [value]="manageBriefTabsService.focussedBrief()!.shoutBrief!.suggestedHastags"
                        placeholder="Enter your hashtags here..."
                        class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"></textarea>
                </div>
                } @else {
                <div class="w-full mt-2 flex flex-row items-center justify-start gap-x-2">
                    <span
                        class="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20">Un-Set</span>
                </div>
                }
            </div>
            <div class="sm:col-span-1">
                <label for="comment" class="block text-sm/6 font-medium text-primary">
                    CTA Link
                    <p class="text-xs text-secondary">The link creators must share with their audience.</p>
                </label>
                @if (manageBriefTabsService.focussedBrief()!.shoutBrief!.callToActionLink) {
                <div class="mt-2 flex">
                    <div
                        class="flex shrink-0 items-center rounded-l-md bg-white px-3 text-base text-gray-500 outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 dark:bg-white/5 dark:text-gray-400 dark:outline-gray-700">
                        https://</div>
                    <input id="company-website" id="link" type="url" disabled
                        [value]="manageBriefTabsService.focussedBrief()!.shoutBrief!.callToActionLink"
                        class="-ml-px block w-full grow rounded-r-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-primary" />
                </div>
                } @else {
                <div class="w-full mt-2 flex flex-row items-center justify-start gap-x-2">
                    <span
                        class="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20">Un-Set</span>
                </div>
                }
            </div>
        </div>

    </article>
    }
</div>
